import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=724c73eb&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=724c73eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724c73eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('724c73eb')) {
      api.createRecord('724c73eb', component.options)
    } else {
      api.reload('724c73eb', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=724c73eb&scoped=true&", function () {
      api.rerender('724c73eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2N6jo8SCr4F4R/JS/comp/PopupBox.vue"
export default component.exports